import { type ThemeId } from '../schema/ThemeId';
import {
    isSportsThemingEnabled,
    isT20WorldCupThemingEnabled,
    isThemingEnabled,
} from './isThemingEnabled';

export const COLOR_THEMES = ['Blue', 'Purple', 'Pink', 'Orange', 'Red', 'Green'];
export const CRICKET_THEMES = [
    'India',
    'Australia',
    'England',
    'SouthAfrica',
    'NewZealand',
    'WestIndies',
    'Pakistan',
    'SriLanka',
    'Bangladesh',
    'Afghanistan',
    'Ireland',
    'Scotland',
    'Namibia',
    'Netherlands',
    'Nepal',
    'Oman',
    'USA',
    'PapuaNewGuinea',
    'Uganda',
    'Canada',
];

export const SPORTS_THEMES = [
    'Athletics',
    'Gymnastics',
    'Swimming',
    'Football',
    'Weightlifting',
    'Basketball',
    'Tennis',
    'Boxing',
    'Handball',
    'Volleyball',
];

export const getSupportedThemes = (): ThemeId[] => {
    const supportedThemes = [];
    if (isThemingEnabled()) {
        supportedThemes.push(...COLOR_THEMES);
    }

    if (isT20WorldCupThemingEnabled()) {
        supportedThemes.push(...CRICKET_THEMES);
    }

    if (isSportsThemingEnabled()) {
        supportedThemes.push(...SPORTS_THEMES);
    }

    return supportedThemes;
};
